import StudentPerformanceTaskSubmit from './StudentPerformanceTaskSubmit';
import StudentPerformanceTaskDetails from './StudentPerformanceTaskDetails';
import { detectMicrocredentialsTaskMode } from '../../../config/microcredentialsTaskModules';
import '../../../pages/HomeworksPage/Components/Submissions.css';

export default function StudentPerformanceTaskDetailsSubmit({
   performanceTaskID,
   onSubmitCallback,
   canSubmit,
   returned,
   remarks,
   submitRef,
   mode = detectMicrocredentialsTaskMode(window.location?.pathname),
}) {
   return (
      <div className="homework-details-submit-shell performance-task-details-submit-shell">
         <section className="homework-details-submit-panel">
            <StudentPerformanceTaskDetails performanceTaskID={performanceTaskID} mode={mode} />
         </section>
         {
            canSubmit && (
               <section className="homework-details-submit-panel homework-submit-panel">
                  <StudentPerformanceTaskSubmit
                     ref={submitRef}
                     performanceTaskID={performanceTaskID}
                     onSubmitCallback={onSubmitCallback}
                     canSubmit={canSubmit}
                     returned={returned}
                     remarks={remarks}
                     showInlineActions={false}
                     mode={mode}
                  />
               </section>
            )
         }
      </div>
   );
}
